import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ConfirmModalModule } from 'Angular/features/components/modals/confirm-modal/confirm-modal.module';
import { PromptModalModule } from 'Angular/features/components/modals/prompt-modal/prompt-modal.module';
import { TemplateModalModule } from 'Angular/features/components/modals/template-modal/template-modal.module';
import { OpenItemModalModule } from 'Angular/features/components/saved-items/open-item-modal/open-item-modal.module';
import { DisabledModule } from 'Angular/features/directives/disabled/disabled.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import * as i0 from "@angular/core";
export class SavedItemDropdownModule {
}
SavedItemDropdownModule.ɵfac = function SavedItemDropdownModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SavedItemDropdownModule)(); };
SavedItemDropdownModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: SavedItemDropdownModule });
SavedItemDropdownModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [ConfirmModalModule,
        CommonModule,
        DisabledModule,
        FormsModule,
        IconModule,
        OpenItemModalModule,
        PromptModalModule,
        TemplateModalModule] });
